export default {
  single_attachment: {},
}
